var chunkMapping = {
	"0": [
		4755
	],
	"3": [
		4216
	],
	"74": [
		5169
	],
	"153": [
		5248
	],
	"154": [
		5249
	],
	"157": [
		5252
	],
	"158": [
		5253
	],
	"159": [
		5254
	],
	"160": [
		5255
	],
	"161": [
		5256
	],
	"162": [
		5257
	],
	"163": [
		5258
	],
	"164": [
		5259
	],
	"165": [
		5260
	],
	"166": [
		5261
	],
	"167": [
		5262
	],
	"168": [
		5263
	],
	"169": [
		5264
	],
	"170": [
		5265
	],
	"171": [
		5266
	],
	"172": [
		5267
	],
	"173": [
		5268
	]
};
var idToExternalAndNameMapping = {
	"4216": [
		"default",
		"./nuorder-components",
		4042
	],
	"4755": [
		"default",
		"./Containers",
		3820
	],
	"5169": [
		"default",
		"./OrderlessInvoices",
		3820
	],
	"5248": [
		"default",
		"./AsyncEventTracker",
		3820
	],
	"5249": [
		"default",
		"./HostWrapper",
		3820
	],
	"5252": [
		"default",
		"./CheckoutV3",
		3820
	],
	"5253": [
		"default",
		"./CheckoutConfirmation",
		3820
	],
	"5254": [
		"default",
		"./ContactCreditCards",
		3820
	],
	"5255": [
		"default",
		"./AuditDialog",
		3820
	],
	"5256": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3820
	],
	"5257": [
		"default",
		"./InvoiceDialog",
		3820
	],
	"5258": [
		"default",
		"./PaymentDueModal",
		3820
	],
	"5259": [
		"default",
		"./PaymentModal",
		3820
	],
	"5260": [
		"default",
		"./PaymentHistory",
		3820
	],
	"5261": [
		"default",
		"./PaymentConfigurations",
		3820
	],
	"5262": [
		"default",
		"./PaymentPreferences",
		3820
	],
	"5263": [
		"default",
		"./ManagePaymentProcessing",
		3820
	],
	"5264": [
		"default",
		"./MobilePaymentsWrapper",
		3820
	],
	"5265": [
		"default",
		"./Challenge",
		3820
	],
	"5266": [
		"default",
		"./ManagePaymentMethods",
		3820
	],
	"5267": [
		"default",
		"./LightspeedReports",
		3820
	],
	"5268": [
		"default",
		"./ShippingPromotionsListContainer",
		3820
	]
};
var idToRemoteMap = {
	"4216": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4042
		}
	],
	"4755": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5169": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5248": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5249": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5252": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5253": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5254": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5255": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5256": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5257": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5258": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5259": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5260": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5261": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5262": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5263": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5264": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5265": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5266": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5267": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5268": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}